<ng-content select="[navigation]"></ng-content>
<main class="main">
	@if (!isLoading) {
		@if (data?.length) {
			@if (filteredData?.length) {
				<ng-content select="[content]"></ng-content>
				@if (!teamView()) {
					<ng-container>
						<au-table
							class="desktop"
							[tableSelectedData]="tableSelectedData"
							[tableSelection]="tableSelection"
							[usePlaceholderForAvatar]="usePlaceholderForAvatar"
							[displayedColumns]="displayedColumns"
							[data]="filteredData"
							[actions]="actions"
							[numOfStickyColumns]="numOfStickyColumns"
							[isClickableRow]="isClickableRow"
							(bulkSelection)="bulkSelection.emit($event)"
							(rowCheckboxSelect)="rowCheckboxSelect.emit($event)"
							(rowCheckboxesSelect)="rowCheckboxesSelect.emit($event)"
							(delete)="delete.emit($event)"
							(edit)="edit.emit($event)"
							(reload)="reload.emit($event)"
							(cmmsDelete)="cmmsDelete.emit($event)"
						></au-table>
					</ng-container>
				}
			} @else {
				<ng-content select="[content]"></ng-content>
				@if (!teamView()) {
					<au-table
						class="desktop"
						[isClickableRow]="isClickableRow"
						[tableSelectedData]="tableSelectedData"
						[tableSelection]="tableSelection"
						[usePlaceholderForAvatar]="usePlaceholderForAvatar"
						[displayedColumns]="displayedColumns"
						[data]="data"
						[actions]="actions"
						[openedFromActionCenter]="openedFromActionCenter()"
						[numOfStickyColumns]="numOfStickyColumns"
						(bulkSelection)="bulkSelection.emit($event)"
						(rowCheckboxSelect)="rowCheckboxSelect.emit($event)"
						(delete)="delete.emit($event)"
						(edit)="edit.emit($event)"
						(reload)="reload.emit($event)"
						(selectColumn)="selectColumn.emit($event)"
						(cmmsDelete)="cmmsDelete.emit($event)"
						(tableRowClick)="tableRowClick.emit($event)"
					></au-table>
				}
			}
		} @else {
			<div class="placeholder-wrapper">
				<ng-content select="[empty]"></ng-content>
			</div>
		}
	} @else {
		@if (isLoading) {
			<div class="spinner-wrapper">
				<mat-spinner diameter="60"></mat-spinner>
			</div>
		}
	}
</main>

<ng-template #notFound>
	<div class="placeholder-wrapper">
		<ng-content select="[not]"></ng-content>
	</div>
</ng-template>

<ng-template #simpleData>
	<ng-content select="[content]"></ng-content>
	@if (!teamView()) {
		<ng-container>
			<au-table
				class="desktop"
				[isClickableRow]="isClickableRow"
				[tableSelectedData]="tableSelectedData"
				[tableSelection]="tableSelection"
				[usePlaceholderForAvatar]="usePlaceholderForAvatar"
				[displayedColumns]="displayedColumns"
				[data]="data"
				[actions]="actions"
				[numOfStickyColumns]="numOfStickyColumns"
				[openedFromActionCenter]="openedFromActionCenter()"
				(bulkSelection)="bulkSelection.emit($event)"
				(rowCheckboxSelect)="rowCheckboxSelect.emit($event)"
				(delete)="delete.emit($event)"
				(edit)="edit.emit($event)"
				(reload)="reload.emit($event)"
				(selectColumn)="selectColumn.emit($event)"
				(cmmsDelete)="cmmsDelete.emit($event)"
				(tableRowClick)="tableRowClick.emit($event)"
			></au-table>
		</ng-container>
	}
</ng-template>
